var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"cont",attrs:{"id":"app"}},[(_vm.isShow)?_c('div',[(!['/isAbout','/lxUs'].includes(_vm.$route.path))?_c('allHead'):_vm._e(),_c('router-view')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }